import {
  ExportReportTemplateSelectorModalComponent, type ExportReportTemplateSelectorModalProps,
} from '~/exportReport/templateSelector/exportReportTemplateSelectorModal.component';
import { modalRenderer } from '~/modal/modalRendererRegistry';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportReportTemplateSelector: ExportReportTemplateSelectorModalProps;
  }
}

modalRenderer.register('ExportReportTemplateSelector', ExportReportTemplateSelectorModalComponent);
